/**
 * @file: LeadItem.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * A lead's snapshot line for one covered item (backend `lead_item`). A `plan`
 * item snapshots a maintenance-plan detail (with due date / severity); a
 * `catalog` item is a free service subject picked from the catalog and carries
 * only a name + `subjectType` (the plan fields are null).
 */

export type LeadItemDecision = 'will_fix' | 'declined';

export const LeadItemDecisionLabel: Record<LeadItemDecision, string> = {
  will_fix: '确认维修',
  declined: '暂不维修',
};

export type LeadItemSource = 'plan' | 'catalog';

export interface LeadItem {
  id: string;
  leadId: string;
  source: LeadItemSource;
  planDetailId?: number | null;
  planId?: number | null;
  orderNo: string;
  type: string;
  // ServiceSubjectType for catalog items (drives the icon); null for plan items.
  subjectType?: string | null;
  name: string;
  customLabel?: string | null;
  abnormalLevel?: number | null;
  severityLevel?: number | null;
  nextServiceMileage?: number | null;
  nextServiceDate?: string | null;
  customerDecision?: LeadItemDecision | null;
  isActive: boolean;
  createdAt: string | Date;
  createdBy: number;
  createdByName: string;
  updatedAt?: string | Date | null;
  updatedBy?: number | null;
  updatedByName?: string | null;
}
